import React from 'react';


const PrivacyPolicy = () => {
    return (
        <>
            <div className="container">
                <h1>Privacy Policy</h1>
                <p><strong>Effective Date:</strong> May 30, 2025</p>
                <p>
                Boggler (Private) Limited (“<strong>Boggler</strong>,” “<strong>we</strong>,” “<strong>our</strong>,” or “<strong>us</strong>”) values your privacy. This Privacy Policy describes how we collect, use, share, and protect your information when you interact with:
                </p>
                <ul>
                <li>The Boggler website at <strong>theboggler.com</strong> (“<strong>Website</strong>”); and</li>
                <li>Our mobile applications &mdash; <strong>Buckish</strong>, <strong>Apex</strong>, and <strong>Third View</strong> &mdash; including features such as screenshot uploads and guide reviews (collectively, the “<strong>App</strong>” or “<strong>Apps</strong>”).</li>
                </ul>
                <p>By using our Website or Apps, you consent to the terms of this Privacy Policy.</p>

                <h2>1. Information We Collect</h2>
                <h3>a. Information You Provide</h3>
                <ul>
                <li><strong>Screenshots & Content:</strong> Securely stored and only accessible by your selected guides.</li>
                <li><strong>Account & Payment Info:</strong> Includes your email, payment data, and transaction history. Payments are processed through third-party services (e.g., Stripe, Apple Pay).</li>
                <li><strong>Profile Preferences:</strong> Includes guide selection, emotional indicators, and optional context.</li>
                </ul>
                <h3>b. Information Collected Automatically</h3>
                <ul>
                <li><strong>Device Data:</strong> Device type, OS, browser, and app version.</li>
                <li><strong>Usage Metrics:</strong> Time spent, interactions, and referral data.</li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <ul>
                <li>Provide and enhance our Website and Apps</li>
                <li>Match uploads with selected guides</li>
                <li>Facilitate subscriptions and payments</li>
                <li>Analyze usage patterns and improve services</li>
                <li>Communicate account updates and support</li>
                </ul>

                <h2>3. How We Share Your Information</h2>
                <p>We do <strong>not sell</strong> your data. We may share your information with:</p>
                <ul>
                <li><strong>Guides:</strong> Only those you select.</li>
                <li><strong>Payment Processors:</strong> For handling transactions.</li>
                <li><strong>Service Providers:</strong> Supporting analytics, storage, and security.</li>
                <li><strong>Legal Authorities:</strong> When required by law.</li>
                </ul>

                <h2>4. Data Security</h2>
                <p>We implement standard encryption and access control measures. However, no method is 100% secure, so please exercise caution with sensitive content.</p>

                <h2>5. Your Rights & Choices</h2>
                <ul>
                <li><strong>Access or Deletion:</strong> Email <span onClick={() => window.open("mailto:buck@theboggler.com")}>buck@theboggler.com</span>.</li>
                <li><strong>Marketing Opt-Out:</strong> Unsubscribe at any time.</li>
                <li><strong>Data Portability:</strong> Available on request, pending verification.</li>
                </ul>

                <h2>6. Children’s Privacy</h2>
                <p>Our services are not intended for children under 13. If data is collected from a child, we will delete it immediately.</p>

                <h2>7. International Users</h2>
                <p>Your data may be processed in the USA, Sri Lanka, or other countries with different data protection laws.</p>

                <h2>8. Third-Party Links</h2>
                <p>We are not responsible for the privacy practices of any third-party websites linked within our Website or Apps.</p>

                <h2>9. Changes to This Policy</h2>
                <p>We may update this Privacy Policy periodically. Changes will be reflected by the updated "Effective Date." We will notify you where required by law.</p>

                <h2>10. Contact Us</h2>
                <p>
                <strong>Boggler (Private) Limited</strong><br />
                272b 2/1 High Level Road<br />
                Maharagama 10280, Sri Lanka<br />
                Email: <span onClick={() => window.open("mailto:buck@theboggler.com")}>buck@theboggler.com</span>
                </p>
            </div>
        </>
    );
}

export default PrivacyPolicy;